import PropTypes from "prop-types"
import React, { useState, useEffect } from "react"
import {
    Container,
    Row,
    Col,
    Button,
    Card,
    CardBody,
    Input,
    DropdownToggle,
    DropdownItem,
    DropdownMenu,
} from "reactstrap"
import axios from "axios"
import moment from "moment";
import { Chips } from "primereact/chips";

import { InputText } from "primereact/inputtext"
import { Dropdown } from "primereact/dropdown"
import { MultiSelect } from 'primereact/multiselect';
import { Calendar } from 'primereact/calendar';
import { Link, useNavigate } from 'react-router-dom';
import { Dialog } from 'primereact/dialog';
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { confirmDialog } from "primereact/confirmdialog";
import { ConfirmDialog } from "primereact/confirmdialog";
import { TriStateCheckbox } from "primereact/tristatecheckbox"
import { FileUpload } from 'primereact/fileupload';
import { InputNumber } from "primereact/inputnumber";
import { InputTextarea } from 'primereact/inputtextarea';
import { TreeSelect } from "primereact/treeselect";
import { useForm } from "react-hook-form";


const CandidatePostFormExtra = () => {
    const [menu, setMenu] = useState(false)
    const [fullNameDialogVisible, setFullNameDialogVisible] = useState(false);
    const [totalExperience, setTotalExperience] = useState(null);
    const [address, setAddress] = useState();
    const [currentSalary, setCurrentSalary] = useState(null);
    const [expectedSalary, setExpectedSalary] = useState(null);
    const [educationDetails, setEducationDetails] = useState([]);
    const [isDialogVisible, setIsDialogVisible] = useState(false);
    const [newEducation, setNewEducation] = useState({ degree: '', school_name: '', start_year: '', start_month: '', end_year: '', end_month: "", grade: '', });

    const handleSave1 = () => {
        if (editIndex !== null) {
            const updatedExperiences = [...educationDetails];
            updatedExperiences[editIndex] = newEducation;
            setEducationDetails(updatedExperiences);
            setEditIndex(null);
        } else {
            // Add new record
            setEducationDetails([...educationDetails, newEducation]);
        }
        // setNewEducation({ degree: " ", website: " ", jobTitle: " ", fromDate: null, toDate: null, description: " ", });
        setIsDialogVisible(false);
    };

    const handleSavedocument = () => {
        if (editIndex1 !== null) {
            const updatedExperiences = [...documents];
            updatedExperiences[editIndex] = documentvalu;
            setDocuments(updatedExperiences);
            setEditIndex1(null);
        } else {
            // Add new record
            setDocuments([...documents, documentvalu]);
        }
        setdocumentvalu({ file: "", subject: "", selectedDocument: "" });
        setDisplayDialog(false);
    };

    const [documentvalu, setdocumentvalu] = useState({ file: "", subject: "", selectedDocument: "" })
    const handleInputChange1 = (key, value) => {
        setdocumentvalu((prev) => ({
            ...prev,
            [key]: value,
        }));
    };
    const years = Array.from({ length: 50 }, (_, i) => {
        const year = new Date().getFullYear() - i;
        return { label: year.toString(), value: year.toString() };
    });
    const months = [
        { label: 'January', value: 'January' },
        { label: 'February', value: 'February' },
        { label: 'March', value: 'March' },
        { label: 'April', value: 'April' },
        { label: 'May', value: 'May' },
        { label: 'June', value: 'June' },
        { label: 'July', value: 'July' },
        { label: 'August', value: 'August' },
        { label: 'September', value: 'September' },
        { label: 'October', value: 'October' },
        { label: 'November', value: 'November' },
        { label: 'December', value: 'December' },
    ];

    const [visible, setVisible] = useState(false);
    const [street1, setStreet1] = useState('');
    const [street2, setStreet2] = useState('');
    const [postalCode, setPostalCode] = useState('');
    const [selectedLabel, setSelectedLabel] = useState(null);
    const [selectedLabel1, setSelectedLabel1] = useState(null);
    const [selectedCountry, setSelectedCountry] = useState(null);
    const [selectedState, setSelectedState] = useState(null);
    const [selectedCity, setSelectedCity] = useState(null);
    const [addCountries, setAddCountries] = useState([]);
    const [addStates, setAddStates] = useState([]);
    const [addCities, setAddCities] = useState([]);

    const getaddCountries = async () => {
        try {
            const response = await axios.get(`/api/v1/get-all-countries/`, {});
            const transformedData = response.data.results.map((Countries) => ({
                name: Countries.name,
                id: Countries.country_id,
            }));
            setAddCountries(transformedData);
            console.log(transformedData)

        }
        catch (error) {
        }
    };
    const getaddStates = async (countryId) => {
        try {
            const response = await axios.get(`/api/v1/get-all-states/?country_id=${countryId}`, {});
            const transformedData = response.data.results.map((city) => ({
                name: city.name,
                id: city.state_id,
            }));
            setAddStates(transformedData);
        }
        catch (error) {
        }
    };
    const getaddCities = async (stateId) => {
        try {
            const response = await axios.get(`/api/v1/get-all-cities/?state_id=${stateId}`, {});
            const transformedData = response.data.results.map((city) => ({
                name: city.name,
                id: city.city_id,
            }));
            setAddCities(transformedData);
        }
        catch (error) {
        }
    };

    useEffect(() => {
        getaddCountries()

    }, [])
    useEffect(() => {
        if (selectedCountry) {
            getaddStates(selectedCountry.id);
        }
    }, [selectedCountry]);

    useEffect(() => {
        if (selectedState) {
            getaddCities(selectedState.id);
        }
    }, [selectedState]);
    const labels = [
        { name: 'Work ', code: 'WORK' },
        { name: 'Home', code: 'HOME' },
        { name: 'Other', code: 'Other' },
    ];
    const [basicimp, setbasicimp] = useState()
    const [basictittle, setbasictittle] = useState('');
    const [basicfirst, setbasicfirst] = useState('');
    const [basiclast, setbasiclast] = useState('');
    const [basicmiddle, setbasicmiddle] = useState('');

    useEffect(() => {
        const updatedAddress = [street1, street2, postalCode, selectedState?.name, selectedCity?.name, selectedCountry?.name, selectedLabel?.name, postalCode].filter(Boolean);
        setAddress(updatedAddress);

        const updatenamesbasic = [basictittle, basicfirst, basicmiddle, basiclast].filter(Boolean).join(" ");
        setbasicimp(updatenamesbasic)

    }, [street1, street2, postalCode, selectedState, selectedCity, selectedCountry, selectedLabel, postalCode, basictittle, basicfirst, basicmiddle, basiclast]);

    const groupedDocuments = [
        {
            label: 'Proof of Identity',
            items: [
                { label: 'Aadhaar Card', value: 'Aadhaar Card' },
                { label: 'Passport', value: 'Passport' },
                { label: 'Voter ID', value: 'Voter ID' },
                { label: 'PAN Card', value: 'PAN Card' },
                { label: 'Driver\'s License', value: 'Driver\'s License' }
            ]
        },
        {
            label: 'Educational Qualification Documents',
            items: [
                { label: '10th, 12th Standard Mark Sheets', value: '10th, 12th Standard Mark Sheets' },
                { label: 'Degree/Diploma Certificates', value: 'Degree/Diploma Certificates' },
                { label: 'Consolidated Mark Sheets', value: 'Consolidated Mark Sheets' },
                { label: 'Professional Certification Documents', value: 'Professional Certification Documents' }
            ]
        },
        {
            label: 'Employment-Related Documents',
            items: [
                { label: 'Offer Letter', value: 'Offer Letter' },
                { label: 'Appointment Letter', value: 'Appointment Letter' },
                { label: 'Resume/Curriculum Vitae', value: 'Resume/Curriculum Vitae' },
                { label: 'Previous Employment Experience Certificates', value: 'Previous Employment Experience Certificates' },
                { label: 'Relieving Letters from Previous Employers', value: 'Relieving Letters from Previous Employers' },
                { label: 'Service Certificate', value: 'Service Certificate' },
                { label: 'Last Drawn Salary Slip', value: 'Last Drawn Salary Slip' }
            ]
        },
        {
            label: 'Contact and Address Proof',
            items: [
                { label: 'Permanent Address Proof', value: 'Permanent Address Proof' },
                { label: 'Current Residential Address Proof', value: 'Current Residential Address Proof' },
                { label: 'Local Address Proof', value: 'Local Address Proof' },
                { label: 'Address Verification Documents', value: 'Address Verification Documents' },
                { label: 'Contact Information Form', value: 'Contact Information Form' }
            ]
        },
        {
            label: 'Financial and Tax-Related Documents',
            items: [
                { label: 'PAN Card', value: 'PAN Card' },
                { label: 'Bank Account Details', value: 'Bank Account Details' },
                { label: 'Cancelled Cheque', value: 'Cancelled Cheque' },
                { label: 'Form 16 from Previous Employer', value: 'Form 16 from Previous Employer' },
                { label: 'Tax Identification Documents', value: 'Tax Identification Documents' }
            ]
        },
        {
            label: 'Personal and Medical Documents',
            items: [
                { label: 'Passport-Size Photographs', value: 'Passport-Size Photographs' },
                { label: 'Birth Certificate', value: 'Birth Certificate' },
                { label: 'Marriage Certificate (if applicable)', value: 'Marriage Certificate (if applicable)' },
                { label: 'Passport Details', value: 'Passport Details' },
                { label: 'Medical Fitness Certificate', value: 'Medical Fitness Certificate' },
                { label: 'Police Verification Certificate', value: 'Police Verification Certificate' }
            ]
        },
        {
            label: 'Legal and Compliance Documents',
            items: [
                { label: 'Background Verification Consent Form', value: 'Background Verification Consent Form' },
                { label: 'Non-Disclosure Agreement (NDA)', value: 'Non-Disclosure Agreement (NDA)' },
                { label: 'Employment Bond (if applicable)', value: 'Employment Bond (if applicable)' },
                { label: 'Declaration of No Criminal Record', value: 'Declaration of No Criminal Record' }
            ]
        },
        {
            label: 'Statutory Documentation',
            items: [
                { label: 'Employee Provident Fund (EPF) Registration Form', value: 'Employee Provident Fund (EPF) Registration Form' },
                { label: 'Employee State Insurance (ESI) Form', value: 'Employee State Insurance (ESI) Form' },
                { label: 'Professional Tax Registration Details', value: 'Professional Tax Registration Details' }
            ]
        },
        {
            label: 'Emergency Contact and Nominee Details',
            items: [
                { label: 'Emergency Contact Information Form', value: 'Emergency Contact Information Form' },
                { label: 'Nominee Details for Insurance and Other Benefits', value: 'Nominee Details for Insurance and Other Benefits' },
                { label: 'Personal References', value: 'Personal References' }
            ]
        },
        {
            label: 'Additional Specialized Documents (Depending on Role/Industry)',
            items: [
                { label: 'Professional License Certificates', value: 'Professional License Certificates' },
                { label: 'Specialized Skill Certification', value: 'Specialized Skill Certification' },
                { label: 'Work Permit/Visa Documents (for Foreign Nationals)', value: 'Work Permit/Visa Documents (for Foreign Nationals)' },
                { label: 'Security Clearance Certificates', value: 'Security Clearance Certificates' }
            ]
        }
    ];

    const groupedItemTemplate = (option) => {
        return (
            <div className="flex align-items-center">
                <i className="pi pi-file mr-2"></i>
                <div>{option.label}</div>
            </div>
        );
    };

    const [categoriesitem, setcategoriesitem] = useState([])
    const [selectedCategoryKey, setSelectedCategoryKey] = useState();
    const [groupitem, setgroupitem] = useState([])
    const [selectedGroupKey, setSelectedGroupKey] = useState(null);

    const getcategoriesitemvalues = async () => {
        try {
            const response = await axios.get(`/api/v1/get-all-categories/`, {});
            if (response.data && response.data.results) {
                const transformedData = response.data.results.map((Categories) => ({
                    name: Categories.name,
                    id: Categories.category_id,
                }));
                setcategoriesitem(transformedData);
            }
        } catch (error) {
        }
    };

    const getgroupsitemsub = async (category_ids) => {
        try {
            const response = await axios.get(`/api/v1/get-all-groups/?category_id=${category_ids}`, {});
            if (response.data && response.data.results) {
                const transformedDatagroup = response.data.results.map((Groups) => ({
                    name: Groups.name,
                    id: Groups.group_id,
                }));
                setgroupitem(transformedDatagroup);
            }
        } catch (error) {
        }
    };
    useEffect(() => {
        if (selectedCategoryKey?.id) {
            getgroupsitemsub(selectedCategoryKey.id);
        }
    }, [selectedCategoryKey]);
    useEffect(() => {
        getcategoriesitemvalues()

    }, [])

    const [secondarySkills, setSecondarySkills] = useState(null);
    const [otherSkills, setOtherSkills] = useState([]);
    const [workExperiences, setWorkExperiences] = useState([]);
    const [showDialog, setShowDialog] = useState(false);
    const [formValues, setFormValues] = useState({ company_name: "", website: "", job_title: "", start_date: "", end_date: "", description: "", });
    const [editIndex1, setEditIndex1] = useState(null);
    const [editIndex, setEditIndex] = useState(null);

    // Form Handlers
    const handleInputChange = (key, value) => {
        setFormValues((prev) => ({
            ...prev,
            [key]: value,
        }));
    };

    const handleSave = () => {
        if (editIndex !== null) {
            const updatedExperiences = [...workExperiences];
            updatedExperiences[editIndex] = formValues;
            setWorkExperiences(updatedExperiences);
            setEditIndex(null);
        } else {
            setWorkExperiences([...workExperiences, formValues]);
        }
        // setFormValues({ company: "", website: "", jobTitle: "", fromDate: null, toDate: null, description: "", });
        setShowDialog(false);
    };

    const [documents, setDocuments] = useState([]);
    const [displayDialog, setDisplayDialog] = useState(false); // Modal visibility state
    const openAddDocumentDialog = () => {
        setDisplayDialog(true);
    };
    const closeAddDocumentDialog = () => {
        setDisplayDialog(false);
    };
    const navigate = useNavigate();
    const handleSaveClick = () => {
        setMerge(true);
    };
    const [pathSegment, setPathSegment] = useState(null);
    useEffect(() => {
        const url = new URL(window.location.href); // Get the current URL
        const pathParts = url.pathname.split('/'); // Split the pathname into parts
        const lastSegment = pathParts[pathParts.length - 1]; // Get the last part of the path
        setPathSegment(lastSegment); // Set the last segment to state

    }, []);

    const [merge, setMerge] = useState(false);
    const footerContent = (
        <div className="d-flex justify-content-center">
            <button type="button" onClick={() => {
                navigate('/all_active_employees');

            }} class="btn btn-primary waves-effect waves-light outlinebtn btn btn-primary me-2">Yes</button>

            <button type="button" onClick={() => {
                navigate('/all_active_employees');

            }} class="btn btn-primary waves-effect waves-light outlinebtn btn btn-primary me-2">No</button>
        </div>
    );

    const { register, handleSubmit, reset, trigger, clearErrors, formState: { errors }, setValue, getValues } = useForm();
    const [linkdinval, setlinkdinval] = useState(null)
    const [facebook, setfacebook] = useState(null)
    const [twitter, settwitter] = useState(null)
    const [Indeed, setIndeed] = useState(null)
    const [fileData, setFileData] = useState(null);
    const [error, setError] = useState("");
    // Function to convert file to base64
    const getBase64 = (file) => {
        return new Promise((resolve, reject) => {
            const reader = new FileReader();
            reader.readAsDataURL(file);

            reader.onload = () => {
                const base64String = reader.result.split(",")[1]; // Extract only base64 content
                resolve(base64String);
            };
            reader.onerror = (error) => reject(error);
        });
    };
    const handleFileChange = async (event) => {
        const file = event.target.files[0];
        if (!file) return;
        // Validate file type
        const allowedTypes = ["application/pdf"];
        if (!allowedTypes.includes(file.type)) {
            setError(" PDF files are allowed.");
            return;
        }
        // Validate file size (max 10MB)
        const maxSize = 10 * 1024 * 1024; // 10MB
        if (file.size > maxSize) {
            setError("File size should not exceed 10MB.");
            return;
        }
        setError(""); // Clear errors
        try {
            const base64 = await getBase64(file);
            setFileData(base64); // Store only base64 content
        } catch (error) {
            setError("Error while converting file to base64.");
        }
    };
    // API call to post the base64 data

    const [fileData1, setFileData1] = useState(null);
    const [error1, setError1] = useState("");

    const getBase641 = (file) => {
        return new Promise((resolve, reject) => {
            const reader = new FileReader();
            reader.readAsDataURL(file);

            reader.onload = () => {
                const base64String = reader.result.split(",")[1]; // Extract only base64 content
                resolve(base64String);
            };
            reader.onerror = (error) => reject(error);
        });
    };
    const handleFileChange1 = async (event) => {
        const file = event.target.files[0];
        if (!file) return;
        // Validate file type
        const allowedTypes = ["application/pdf"];
        if (!allowedTypes.includes(file.type)) {
            setError1(" PDF files are allowed.");
            return;
        }
        // Validate file size (max 10MB)
        const maxSize = 10 * 1024 * 1024; // 10MB
        if (file.size > maxSize) {
            setError1("File size should not exceed 10MB.");
            return;
        }
        setError1(""); // Clear errors
        try {
            const base64 = await getBase641(file);
            setFileData1(base64); // Store only base64 content
        } catch (error) {
            setError1("Error while converting file to base64.");
        }
    };


    const onSubmit = async (data) => {
        const req = {};
        // Basic Information
        if (basicfirst) {
            req.first_name = basicfirst;
        }
        if (basiclast) {
            req.last_name = basiclast;
        }
        if (basictittle) {
            req.title = basictittle;
        }
        if (basicmiddle) {
            req.middle_name = basicmiddle;
        }

        // Job & Contact Details
        if (data.JobTitle) {
            req.job_title = data.JobTitle;
        }
        if (data.personal_email) {
            req.email = data.personal_email;
        }
        if (data.Email2) {
            req.email_2 = data.Email2;
        }
        if (data.phone) {
            req.mobile_phone = data.phone;
        }
        if (data.Company) {
            req.current_company = data.Company;
        }
        if (data.Status) {
            req.Status = data.Status;
        }

        // Relocation & Employment
        req.relocation = data.relocation ? "true" : "false";
        if (data.EmployeeType) {
            req.EmployeeType = data.EmployeeType;
        }
        // Salary & Experience
        if (expectedSalary) {
            req.expected_salary = expectedSalary;
        }
        if (currentSalary) {
            req.current_salary = currentSalary;
        }
        if (totalExperience) {
            req.total_experience = totalExperience;
        }
        // Address Details
        if (street1) {
            req.street_address = street1;
        }
        if (street2) {
            req.street_address_line_2 = street2;
        }
        if (selectedState) {
            req.state = selectedState;
        }
        if (selectedCity) {
            req.city = selectedCity;
        }
        if (selectedCountry) {
            req.country = selectedCountry;
        }
        if (postalCode) {
            req.pincode = postalCode;
        }
        if (selectedLabel1) {
            req.address_label = selectedLabel1;
        }

        // Date Fields
        if (data.dob) {
            req.dob = moment(data.dob).format("YYYY-MM-DD");
        }
        if (data.dateAvalibility) {
            req.dateAvalibility = moment(data.dateAvalibility).format("YYYY-MM-DD");
        }
        // Skills & Social Links
        if (otherSkills) {
            req.other_skills = otherSkills;
        }
        // if (primarySkills) {
        //     req.primary_skills = primarySkills;
        // }
        if (primarySkillsview) {
            req.primary_skills = primarySkillsview;
        }
        if (secondarySkills) {
            req.secondary_skills = secondarySkills;
        }
        if (linkdinval) {
            req.linkedin_url = linkdinval;
        }
        if (facebook) {
            req.facebook_url = facebook;
        }
        if (twitter) {
            req.x_url = twitter;
        }
        if (Indeed) {
            req.indeed_url = Indeed;
        }
        // Resume & Uploaded Files
        if (fileData) {
            req.resume = fileData;
        }
        // Categories & Groups
        if (selectedCategoryKey) {
            req.categories = selectedCategoryKey;
        }
        if (selectedGroupKey) {
            req.groups = selectedGroupKey;
        }

        // Work Experience Mapping
        const subdepatt = Array.isArray(workExperiences)
            ? workExperiences
                .map((item) => {
                    if (item.haveError) {
                        return {
                            ...item,
                            haveError: true,
                        };
                    }
                    return item;
                })
                .filter((item) => item.company_name || item.website || item.job_title || item.start_date || item.end_date || item.description) : [];

        // Only add non-empty work details
        if (subdepatt.length > 0) {
            req.work_details = subdepatt;
        }
        // Education Details Mapping
        const educations = educationDetails?.filter(
            (edu) => edu.degree || edu.school_name || edu.start_year || edu.start_month || edu.end_year || edu.end_month || edu.grade);
        if (educations && educations.length > 0) {
            req.educations = educations;
        }

        // Certificates Mapping
        const certificates = documents?.filter(
            (cert) => cert.name || cert.file || cert.subject || cert.selectedDocument);
        if (certificates && certificates.length > 0) {
            req.certificates = certificates;
        }


        try {
            const response = await axios.post(`/api/v1/candidates/`, req, {});
            navigate('/all_active_employees');
        } catch (error) {
        }
    };

    useEffect(() => {
        if (pathSegment) { }
    }, [pathSegment]);
    const [primarySkillsview, setprimarySkillsview] = useState(null);
    const [primarySkillsget, setprimarySkillsget] = useState([]);
    const getskills = async () => {
        try {
            const response = await axios.get(`/api/v1/get-all-skills/`, {});
            const transformedData = response.data.results.map((workv) => ({
                name: workv.skill_name,
                id: workv.skill_id,
            }));
            setprimarySkillsget(transformedData);

        }
        catch (error) {
        }
    };

    useEffect(() => {
        getskills()
    }, [])

    return (
        <React.Fragment>
            <div className="page-content">
                <Container fluid>
                    <div className="page-title-box">
                        <Row className="align-items-center">
                            <Col md={6}>
                                <h1 className="page-title">Create a Candidate</h1>
                                <ol className="breadcrumb m-0">
                                    <li className="breadcrumb-item active">
                                        Add a new candidate by entering their details, skills, and contact information to streamline recruitment.
                                    </li>
                                </ol>
                            </Col>
                            <Col md={6}>
                                <div className="d-flex justify-content-end">
                                    <button type="button" onClick={handleSaveClick} class="btn btn-primary waves-effect waves-light btn btn-primary me-2 btn-main">Save</button>
                                    <Link to={`/all_active_employees`} > <button type="button" class="btn btn-primary waves-effect waves-light me-2 cancel-outlinebtn" >Cancel<i className="pi pi-times me-1"></i></button></Link>
                                </div>
                            </Col>
                        </Row>
                    </div>
                    <form onSubmit={handleSubmit(onSubmit)}>
                        <Row>
                            <Col xl={4}>
                                <Card className="bg-form">
                                    <CardBody>
                                        <h4 className="card-title mb-2">Basic Information</h4>
                                        <Row>
                                            <Col xl={12}>
                                                <div className="">
                                                    <Row>
                                                        <Col xl={12}>
                                                            <Row className="mt-2 align-items-center"   >
                                                                <Col xl={3}>
                                                                    <label className=" block mb-2">Full name</label>
                                                                </Col>
                                                                <Col xl={9}>
                                                                    <InputText
                                                                        className="w-full"
                                                                        placeholder=""
                                                                        value={basicimp}
                                                                        style={{ position: "relative" }}
                                                                    // {...register("firstname", {
                                                                    //   required: "First name is required",
                                                                    //   pattern: {
                                                                    //     value: /^[A-Za-z][A-Za-z-\s&]+$/,
                                                                    //     message:
                                                                    //       "This field allows only alphabets and spaces, but does not accept a space as the first character.",
                                                                    //   },
                                                                    // })}
                                                                    // onKeyUp={() => { trigger("firstname") }}
                                                                    />
                                                                    {/* {errors.firstname && (<small id='personalEmailHelp' className='form-text text-danger'>{errors.firstname.message}</small>)} */}
                                                                    <i className="pi pi-pencil" style={{ position: "absolute", right: "26px", top: "28%", transform: "translateY(-50%)", color: "#6c757d", cursor: "pointer" }}
                                                                        onClick={() => setFullNameDialogVisible(true)}
                                                                    ></i>
                                                                    <Dialog header="Edit Full Name"
                                                                        visible={fullNameDialogVisible}
                                                                        onHide={() => setFullNameDialogVisible(false)}
                                                                        style={{ width: '30vw' }}
                                                                        breakpoints={{ '960px': '75vw', '641px': '100vw' }}>

                                                                        <Row className="mb-2">
                                                                            <Col xl={12}>
                                                                                <label htmlFor="title" className="block">Title</label>
                                                                                <select className="form-select mb-1"
                                                                                    value={basictittle}
                                                                                    onChange={(e) => { setbasictittle(e.target.value); }}
                                                                                >
                                                                                    <option value="">Select Title</option>
                                                                                    <option value="Mr.">Mr.</option>
                                                                                    <option value="Mrs">Mrs</option>
                                                                                    <option value="Miss">Miss</option>
                                                                                    <option value="Ms">Ms</option>
                                                                                </select>
                                                                            </Col>
                                                                        </Row>
                                                                        <Row className="mb-2">
                                                                            <Col xl={12}>
                                                                                <label htmlFor="title" className="block">First Name</label>
                                                                                <InputText id="title" className="w-full"
                                                                                    value={basicfirst}
                                                                                    onChange={(e) => { setbasicfirst(e.target.value); }}
                                                                                />
                                                                            </Col>
                                                                        </Row>

                                                                        <Row className="mb-2">
                                                                            <Col xl={12}>
                                                                                <label htmlFor="title" className="block">Middle Name</label>
                                                                                <InputText id="title" className="w-full"
                                                                                    value={basicmiddle}
                                                                                    onChange={(e) => { setbasicmiddle(e.target.value); }} />
                                                                            </Col>
                                                                        </Row>
                                                                        <Row className="mb-2">
                                                                            <Col xl={12}>
                                                                                <label htmlFor="title" className="block">Last Name</label>
                                                                                <InputText id="title" className="w-full"
                                                                                    value={basiclast}
                                                                                    onChange={(e) => { setbasiclast(e.target.value); }} />
                                                                            </Col>
                                                                        </Row>
                                                                        <Row>
                                                                            <Col xl={12}>
                                                                                <div className="d-flex justify-content-end mt-2">
                                                                                    <Button color="primary btn-main mr-2" onClick={() => setFullNameDialogVisible(false)}>
                                                                                        Ok
                                                                                    </Button>
                                                                                </div>
                                                                            </Col>
                                                                        </Row>
                                                                    </Dialog>
                                                                </Col>
                                                            </Row>
                                                            <Row className="mt-2 align-items-center">
                                                                <Col xl={3}>
                                                                    <label className=" block mb-2">Company</label>
                                                                </Col>
                                                                <Col xl={9}>
                                                                    <InputText className="w-full"
                                                                        {...register("Company", {
                                                                            required: "Company name is required",
                                                                            pattern: {
                                                                                value: /^[A-Za-z][A-Za-z-\s&]+$/,
                                                                                // message:
                                                                                //   "This field allows only alphabets and spaces, but does not accept a space as the first character.",
                                                                            },
                                                                        })}
                                                                        onKeyUp={() => { trigger("Company") }} />
                                                                    {errors.Company && (<small id='personalEmailHelp' className='form-text text-danger'>{errors.Company.message}</small>)}
                                                                </Col>
                                                            </Row>

                                                            <Row className="mt-2 align-items-center">
                                                                <Col xl={3}>
                                                                    <label className=" block mb-2">JobTitle</label>
                                                                </Col>
                                                                <Col xl={9}>
                                                                    <InputText className="w-full"
                                                                        {...register("JobTitle", {
                                                                            required: "JobTitle  is required",
                                                                            pattern: {
                                                                                value: /^[A-Za-z][A-Za-z-\s&]+$/,
                                                                                // message:
                                                                                //   "This field allows only alphabets and spaces, but does not accept a space as the first character.",
                                                                            },
                                                                        })}
                                                                        onKeyUp={() => { trigger("JobTitle") }} />
                                                                    {errors.JobTitle && (<small id='personalEmailHelp' className='form-text text-danger'>{errors.JobTitle.message}</small>)}
                                                                </Col>
                                                            </Row>

                                                            <Row className="mt-2 align-items-center">
                                                                <Col xl={3}>
                                                                    <label className="block mb-2">Status</label>
                                                                </Col>
                                                                <Col xl={9}>
                                                                    <div className="card flex justify-content-center mb-0">
                                                                        <select className='form-select profileDetailsInput' id="MyPro_EmpDet_Team_WorkInfo_DesSelBox"
                                                                            aria-label='Default select example'
                                                                            {...register("Status", {
                                                                                // required: "This field is required",
                                                                            })}>
                                                                            <option value=''>--Select --</option>
                                                                            <option value='Active'>Active</option>
                                                                            <option value='InActive'>InActive </option>
                                                                        </select>
                                                                    </div>
                                                                </Col>
                                                            </Row>
                                                            <Row className="mt-2 align-items-center">
                                                                <Col xl={3}>
                                                                    <label htmlFor="totalExperience" className="block mb-2">Total Experience</label>
                                                                </Col>
                                                                <Col xl={9}>
                                                                    <InputNumber
                                                                        inputId="totalExperience"
                                                                        value={totalExperience}
                                                                        onValueChange={(e) => setTotalExperience(e.value)}
                                                                        minFractionDigits={1}
                                                                        maxFractionDigits={1}
                                                                        mode="decimal"
                                                                        placeholder=""
                                                                        className="w-full drop-clr" />
                                                                </Col>
                                                            </Row>
                                                        </Col>
                                                    </Row>
                                                </div>
                                            </Col>
                                        </Row>
                                    </CardBody>
                                </Card>
                                <Card className="bg-form">
                                    <CardBody>
                                        <h4 className="card-title mb-2">Contact Information</h4>
                                        <Row>
                                            <Col xl={12}>
                                                <div className="">
                                                    <Row>
                                                        <Col xl={12}>
                                                            <Row className="mt-2 align-items-center">
                                                                <Col xl={3}>
                                                                    <label className=" block mb-2">Email 1</label>
                                                                </Col>
                                                                <Col xl={9}>
                                                                    <InputText id="email" name="email" className="w-full"
                                                                        {...register("personal_email", {
                                                                            required: "Please enter  Email",
                                                                            pattern: {
                                                                                value:
                                                                                    /^[A-Z0-9._%+-]+@[A-Z.-]{2,}\.+[A-Z]{2,}$/i,
                                                                                message:
                                                                                    "Please enter valid Email", // JS only: <p>error message</p> TS only support string
                                                                            },
                                                                            onChange: (event) => event.target.value = event.target.value.toLowerCase()
                                                                        })} />
                                                                    {errors.personal_email && (<small id='personalEmailHelp' className='form-text text-danger'>{errors.personal_email.message}</small>)}
                                                                </Col>
                                                            </Row>

                                                            <Row className="mt-2 align-items-center">
                                                                <Col xl={3}>
                                                                    <label className=" block mb-2">Email 2</label>
                                                                </Col>
                                                                <Col xl={9}>
                                                                    <InputText className="w-full"
                                                                        {...register("Email2", {})} />
                                                                </Col>
                                                            </Row>
                                                            <Row className="mt-2 align-items-center">
                                                                <Col xl={3}>
                                                                    <label className=" block mb-2">Work Phone</label>
                                                                </Col>
                                                                <Col xl={9}>
                                                                    <InputText id="integer" keyfilter="int" className="w-full" />
                                                                </Col>
                                                            </Row>
                                                            <Row className="mt-2 align-items-center">
                                                                <Col xl={3}>
                                                                    <label className=" block mb-2">Mobile Phone</label>
                                                                </Col>
                                                                <Col xl={9}>
                                                                    <InputText
                                                                        className="w-full"
                                                                        {...register("phone", {
                                                                            // required: "This field is required",
                                                                            // pattern: {
                                                                            //   value:
                                                                            //     /^(?:(?:\+|0{0,2})91(\s*|[\-])?|[0]?)?([6789]\d{2}([ -]?)\d{3}([ -]?)\d{4})$/,
                                                                            //   message: "Please enter a valid mobile number.",
                                                                            // },
                                                                            // minLength: {
                                                                            //   value: 10,
                                                                            //   message: "Please enter Min and Max 10 digits ",
                                                                            // },
                                                                            // maxLength: {
                                                                            //   value: 10,
                                                                            //   message: "Please enter Min and Max 10 digits ",
                                                                            // },
                                                                        })}

                                                                    // onKeyUp={(e) => {
                                                                    //   trigger("phone");
                                                                    // }}
                                                                    />
                                                                    {/* {errors.phone && (<small id='phoneNoHelp' className='form-text text-danger'>{errors.phone.message}</small>)} */}
                                                                </Col>
                                                            </Row>
                                                            <Row className="mt-2 align-items-center">
                                                                <Col xl={3}>
                                                                    <label htmlFor="address">Address</label>
                                                                </Col>
                                                                <Col xl={9}>
                                                                    <div className="companie-add" style={{ position: "relative" }}>
                                                                        <InputTextarea
                                                                            id="address" value={address}
                                                                            readOnly placeholder=""
                                                                            rows={3} cols={20}
                                                                            className="w-full" />
                                                                        <i className="pi pi-pencil"
                                                                            style={{
                                                                                position: "absolute",
                                                                                right: "10px",
                                                                                top: "70%",
                                                                                transform: "translateY(-50%)",
                                                                                color: "#6c757d",
                                                                                cursor: "pointer"
                                                                            }}
                                                                            onClick={() => setVisible(true)}
                                                                        ></i>
                                                                        <Dialog header="Edit Address" className="address-popup" visible={visible} onHide={() => { if (!visible) return; setVisible(false); }}
                                                                            style={{ width: '30vw' }} breakpoints={{ '960px': '75vw', '641px': '100vw' }}>
                                                                            <div className="card sidebardetails">
                                                                                <form>
                                                                                    <Row className="mb-3">
                                                                                        <Col lg={6}>
                                                                                            <div className="p-field">
                                                                                                <label htmlFor="street1">Street 1</label>
                                                                                                <InputText id="street1"
                                                                                                    value={street1}
                                                                                                    onChange={(e) => { setStreet1(e.target.value); }}
                                                                                                    placeholder="Enter Street 1"
                                                                                                    className="w-full activejobdrop" />
                                                                                            </div>
                                                                                        </Col>
                                                                                        <Col lg={6}>
                                                                                            <label htmlFor="street2">Street 2</label>
                                                                                            <InputText id="street2"
                                                                                                value={street2}
                                                                                                onChange={(e) => { setStreet2(e.target.value); }}
                                                                                                placeholder="Enter Street 2 (Optional)"
                                                                                                className="w-full activejobdrop" />
                                                                                        </Col>
                                                                                    </Row>
                                                                                    <Row className="mb-3">
                                                                                        <Col lg={6}>
                                                                                            <label htmlFor="country">Country</label>
                                                                                            <Dropdown id="country"
                                                                                                value={selectedCountry}
                                                                                                onChange={(e) => { setSelectedCountry(e.value) }}
                                                                                                options={addCountries}
                                                                                                optionLabel="name"
                                                                                                optionValue="id"
                                                                                                filter
                                                                                                filterPlaceholder="Search Country"
                                                                                                className="w-full activejobdrop"
                                                                                                placeholder="Enter country details..." />
                                                                                        </Col>
                                                                                        <Col lg={6}>
                                                                                            <label htmlFor="state">State</label>
                                                                                            <Dropdown id="state"
                                                                                                value={selectedState}
                                                                                                onChange={(e) => { setSelectedState(e.value) }}
                                                                                                options={addStates}
                                                                                                optionLabel="name"
                                                                                                optionValue="id"
                                                                                                filter
                                                                                                filterPlaceholder="Search State"
                                                                                                className="w-full activejobdrop"
                                                                                                placeholder="Enter state details..." />
                                                                                        </Col>
                                                                                    </Row>
                                                                                    <Row className="mb-3">
                                                                                        <Col lg={6}>
                                                                                            <label htmlFor="city">City</label>
                                                                                            <Dropdown id="city"
                                                                                                value={selectedCity}
                                                                                                onChange={(e) => { setSelectedCity(e.value) }}
                                                                                                options={addCities}
                                                                                                optionLabel="name"
                                                                                                optionValue="id"
                                                                                                filter
                                                                                                filterPlaceholder="Search City"
                                                                                                className="w-full activejobdrop"
                                                                                                placeholder="Enter city details..." />
                                                                                        </Col>
                                                                                        <Col lg={6}>
                                                                                            <label htmlFor="postalCode">Postal Code</label>
                                                                                            <InputText id="postalCode"
                                                                                                value={postalCode}
                                                                                                onChange={(e) => { setPostalCode(e.target.value) }}
                                                                                                placeholder="Enter Postal Code"
                                                                                                className="w-full activejobdrop" />
                                                                                        </Col>
                                                                                    </Row>
                                                                                    <Row className="mb-3">
                                                                                        <Col lg={12}>
                                                                                            <label htmlFor="postalCode">Label</label>
                                                                                            <Dropdown value={selectedLabel1}
                                                                                                onChange={(e) => { setSelectedLabel1(e.value) }}
                                                                                                options={labels}
                                                                                                optionLabel="name"
                                                                                                placeholder="Select a Label"
                                                                                                className="w-full activejobdrop" />
                                                                                        </Col>
                                                                                    </Row>
                                                                                    <Row>
                                                                                        <Col>
                                                                                            <Button type="button" color="primary" className="btn btn-primary  waves-light me-2 sidebarbtn" onClick={() => setVisible(false)}>
                                                                                                <i className="pi pi-check me-1" ></i>  Ok
                                                                                            </Button>
                                                                                        </Col>
                                                                                    </Row>
                                                                                </form>
                                                                            </div>
                                                                        </Dialog>
                                                                    </div>
                                                                </Col>
                                                            </Row>
                                                        </Col>
                                                    </Row>
                                                </div>
                                            </Col>
                                        </Row>
                                    </CardBody>
                                </Card>

                                <Card className="bg-form">
                                    <CardBody>
                                        <h4 className="card-title mb-2">Skills</h4>
                                        <Row>
                                            <Col xl={12}>
                                                <div className="">
                                                    <Row>
                                                        <Col xl={12}>
                                                            <Row className="mt-2 align-items-center">
                                                                <Col xl={3}>
                                                                    <label htmlFor="primarySkills" className="mb-0">Skills</label>
                                                                </Col>
                                                                <Col xl={9}>
                                                                    <Dropdown
                                                                        id="jobLocation"
                                                                        value={primarySkillsview}
                                                                        onChange={(e) => setprimarySkillsview(e.value)}
                                                                        options={primarySkillsget}
                                                                        optionLabel="name"
                                                                        optionValue="id"
                                                                        filter
                                                                        filterPlaceholder="Search Location"
                                                                        className="w-full activejobdrop"
                                                                        placeholder="Enter "
                                                                    />
                                                                </Col>
                                                            </Row>
                                                            <Row className="mt-2 align-items-center">
                                                                <Col xl={3}>
                                                                    <label htmlFor="secondary" className="block mb-2">Secondary Skills</label>
                                                                </Col>
                                                                <Col xl={9}>
                                                                    <Chips value={secondarySkills}
                                                                        onChange={(e) => setSecondarySkills(e.target.value)} />
                                                                </Col>
                                                            </Row>
                                                            <Row className="mt-2 align-items-center">
                                                                <Col xl={3}>
                                                                    <label htmlFor="other" className="block mb-2">Other Skills</label>
                                                                </Col>
                                                                <Col xl={9}>
                                                                    <Chips value={otherSkills}
                                                                        onChange={(e) => setOtherSkills(e.target.value)} />
                                                                </Col>
                                                            </Row>
                                                        </Col>
                                                    </Row>
                                                </div>
                                            </Col>
                                        </Row>
                                    </CardBody>
                                </Card>
                            </Col>
                            <Col xl={4}>
                                <Card className="bg-form">
                                    <CardBody>
                                        <h4 className="card-title mb-2">General Information</h4>
                                        <Row>
                                            <Col xl={12}>
                                                <div className="">
                                                    <Row>
                                                        <Col xl={12} >
                                                            <Row className="mt-2 align-items-center">
                                                                <Col xl={3}>
                                                                    <label htmlFor="currentSalary" className="block mb-2">Current Salary</label>
                                                                </Col>
                                                                <Col xl={9}>
                                                                    <InputNumber inputId="currentSalary"
                                                                        value={currentSalary}
                                                                        onValueChange={(e) => setCurrentSalary(e.value)}
                                                                        mode="currency"
                                                                        currency="INR"
                                                                        locale="en-IN"
                                                                        placeholder="Enter current  annual salary"
                                                                        className="w-full" />
                                                                </Col>
                                                            </Row>

                                                            <Row className="mt-2 align-items-center">
                                                                <Col xl={3}>
                                                                    <label htmlFor="expectedSalary" className="block mb-2">Expected Salary</label>
                                                                </Col>
                                                                <Col xl={9}>
                                                                    <InputNumber inputId="expectedSalary"
                                                                        value={expectedSalary}
                                                                        onValueChange={(e) => setExpectedSalary(e.value)}
                                                                        mode="currency"
                                                                        currency="INR"
                                                                        locale="en-IN"
                                                                        placeholder="Enter expected  annual salary"
                                                                        className="w-full" />
                                                                </Col>
                                                            </Row>
                                                            <Row className="mt-2 align-items-center">
                                                                <Col xl={3}>
                                                                    <label htmlFor="employeeType" className="block mb-2">Employee Type</label>
                                                                </Col>
                                                                <Col xl={9}>
                                                                    <div className="card flex justify-content-center mb-0">
                                                                        <select className='form-select profileDetailsInput' id="MyPro_EmpDet_Team_WorkInfo_DesSelBox"
                                                                            aria-label='Default select example'
                                                                            {...register("EmployeeType", {
                                                                                // required: "This field is required",
                                                                            })}>
                                                                            <option value=''>--Select --</option>
                                                                            <option value='Active'>Work From Office</option>
                                                                            <option value='Work From Remote'>Work From Remote </option>
                                                                            <option value='Work From Home'>Work From Home </option>
                                                                            <option value='Freelancer'>Freelancer </option>
                                                                        </select>
                                                                    </div>
                                                                </Col>
                                                            </Row>


                                                            <Row className="mt-2 align-items-center">
                                                                <Col xl={3}>
                                                                    <label className=" block mb-2">DoB</label>
                                                                </Col>
                                                                <Col xl={9}>
                                                                    <input id="AR_AHistory_User_DateFilterInput" type="date" class="form-control" {...register("dob", {})} />
                                                                </Col>
                                                            </Row>

                                                            <Row>
                                                                <Col lg={6}>
                                                                    <Row className="mt-2 align-items-center justify-content-end">
                                                                        <Col lg={12}>
                                                                            <Row>
                                                                                <Col xl={6}>
                                                                                    <label className=" block mb-2">Relocation</label>
                                                                                </Col>
                                                                                <Col xl={6}>
                                                                                    <div className="relocation">
                                                                                        <input type='checkbox'
                                                                                            {...register("relocation", {})}
                                                                                            onKeyUp={() => {
                                                                                                trigger("relocation");
                                                                                            }}
                                                                                            className="me-2" />
                                                                                    </div>
                                                                                </Col>
                                                                            </Row>
                                                                        </Col>
                                                                    </Row>
                                                                </Col>
                                                                <Col lg={6}>
                                                                    <Row className="mt-2 align-items-center">
                                                                        <Col xl={3}>
                                                                            <label htmlFor="jobType">Private</label>
                                                                        </Col>
                                                                        <Col xl={9}>
                                                                            <input type='checkbox' className="me-2" />
                                                                        </Col>
                                                                    </Row>
                                                                </Col>
                                                            </Row>

                                                            <Row className="mt-2 align-items-center">
                                                                <Col xl={3}>
                                                                    <label className=" block mb-2">Availability Date</label>
                                                                </Col>
                                                                <Col xl={9}>
                                                                    <input id="AR_AHistory_User_DateFilterInput" type="date" class="form-control" {...register("dateAvalibility", {})}
                                                                        onKeyUp={() => {
                                                                            trigger("dateAvalibility");
                                                                        }} ></input>
                                                                </Col>
                                                            </Row>

                                                            <Row className="mt-2 align-items-center">
                                                                <Col xl={3}>
                                                                    <label className=" block mb-2">Source</label>
                                                                </Col>
                                                                <Col xl={9}>
                                                                    <InputText id="integer" keyfilter="int" className="w-full" />
                                                                </Col>
                                                            </Row>
                                                            <Row className="mt-2 align-items-center">
                                                                <Col xl={3}>
                                                                    <label className=" block mb-2">Referred By</label>
                                                                </Col>
                                                                <Col xl={9}>
                                                                    <InputText id="integer" keyfilter="int" className="w-full" />
                                                                </Col>
                                                            </Row>

                                                            <Row className="mt-2 align-items-center">
                                                                <Col xl={3}>
                                                                    <label className=" block mb-2">Categories</label>
                                                                </Col>
                                                                <Col xl={9}>
                                                                    <Dropdown value={selectedCategoryKey}
                                                                        onChange={(e) => setSelectedCategoryKey(e.value)}
                                                                        options={categoriesitem}
                                                                        filter
                                                                        optionLabel="name"
                                                                        optionValue="id"
                                                                        className="w-full"
                                                                        placeholder="Select Category" />
                                                                </Col>
                                                            </Row>
                                                            <Row className="mt-2 align-items-center">
                                                                <Col xl={3}>
                                                                    <label className=" block mb-2">Groups</label>
                                                                </Col>
                                                                <Col xl={9}>
                                                                    <Dropdown value={selectedGroupKey}
                                                                        onChange={(e) => setSelectedGroupKey(e.value)}
                                                                        options={groupitem}
                                                                        optionLabel="name"
                                                                        optionValue="id"
                                                                        filter
                                                                        className="w-full"
                                                                        placeholder="Select Group" />
                                                                </Col>
                                                            </Row>
                                                            <Row className="mt-2 align-items-center">
                                                                <Col xl={3}>
                                                                    <label htmlFor="jobType">UserIDs</label>
                                                                </Col>
                                                                <Col xl={9}>
                                                                    <div className="p-field card mb-0">
                                                                        <Dropdown
                                                                            onChange={(e) => setSelectedUserId(e.value)}
                                                                            editable
                                                                            placeholder="Select a User ID"
                                                                            className="w-full activejobdrop" />
                                                                    </div>
                                                                </Col>
                                                            </Row>
                                                        </Col>
                                                    </Row>
                                                </div>
                                            </Col>
                                        </Row>
                                    </CardBody>
                                </Card>
                                <Card className="bg-form">
                                    <CardBody>
                                        <h4 className="card-title mb-2">Resume </h4>
                                        <Row>
                                            <Col xl={12}>
                                                <div className="">
                                                    <Row>
                                                        <Col xl={12}>
                                                            <Row className="mt-2 align-items-center">
                                                                <Col xl={3}>
                                                                    <label className=" block mb-2">Resume Attachment</label>
                                                                </Col>
                                                                <Col xl={9}>
                                                                    <input type="file"
                                                                        accept="image/jpg,image/jpeg,image/png,application/pdf"
                                                                        className="form-control addEmp_ProfilePhoto"
                                                                        id="MyPro_UploadedProfilePhoto_Modal_FilesInput"
                                                                        onChange={handleFileChange}
                                                                    />
                                                                    {error && <small className="text-danger">{error}</small>}
                                                                </Col>
                                                            </Row>
                                                        </Col>
                                                    </Row>
                                                </div>
                                            </Col>
                                        </Row>
                                    </CardBody>
                                </Card>

                                <Card className="bg-form">
                                    <CardBody>
                                        <h4 className="card-title mb-2">Documents</h4>
                                        <Row>
                                            <Col xl={12}>
                                                <div>
                                                    <Row className="mt-2">
                                                        <Col xl={12}>
                                                            <DataTable value={documents} rows={5} className="p-datatable-gridlines"
                                                                emptyMessage={<div className="empty-message-custom">No education details found.</div>}>
                                                                <Column field="selectedDocument" header="Type" />
                                                                <Column field="subject" header="Subject" />
                                                                <Column field="file" header="Attachment" body={(rowData) => rowData.file ? rowData.file.name : 'No file'} />
                                                            </DataTable>
                                                        </Col>
                                                    </Row>
                                                    <div className="block d-flex justify-content-end align-items-center">
                                                        <a color="primary" className="anchr-title  mt-3" onClick={openAddDocumentDialog}>
                                                            <i className="pi pi-plus me-1"></i> Add More
                                                        </a>
                                                    </div>
                                                </div>
                                            </Col>
                                        </Row>
                                    </CardBody>
                                    <Dialog header="Add Document" visible={displayDialog}
                                        onHide={closeAddDocumentDialog}
                                        style={{ width: "30vw" }}>
                                        <Row className="mt-2 align-items-center">
                                            <Col xl={3}>
                                                <label htmlFor="type" className="block mb-2">Type</label>
                                            </Col>
                                            <Col xl={9}>
                                                <Dropdown
                                                    options={groupedDocuments}
                                                    optionLabel="label"
                                                    optionGroupLabel="label"
                                                    optionGroupChildren="items"
                                                    optionGroupTemplate={groupedItemTemplate}
                                                    className="w-full bgclr"
                                                    placeholder="Select a Document"
                                                    value={documentvalu.selectedDocument}
                                                    onChange={(e) => handleInputChange1("selectedDocument", e.target.value)}
                                                />
                                            </Col>
                                        </Row>
                                        <Row className="mt-2 align-items-center">
                                            <Col xl={3}>
                                                <label htmlFor="subject" className="block mb-2">Subject</label>
                                            </Col>
                                            <Col xl={9}>
                                                <InputText id="subject"
                                                    value={documentvalu.subject}
                                                    onChange={(e) => handleInputChange1("subject", e.target.value)}
                                                    className="w-full" />
                                            </Col>
                                        </Row>
                                        <Row className="mt-2 align-items-center">
                                            <Col xl={3}>
                                                <label htmlFor="attachment" className="block mb-2">Attachment</label>
                                            </Col>
                                            <Col xl={9}>
                                                <input type="file" accept="image/jpg,image/jpeg,image/png,application/pdf"
                                                    className="form-control addEmp_ProfilePhoto"
                                                    id="MyPro_UploadedProfilePhoto_Modal_FilesInput"
                                                    onChange={handleFileChange1} />
                                                {error && <small className="text-danger">{error}</small>}
                                            </Col>
                                        </Row>
                                        <Row>
                                            <Col xl={12}>
                                                <div className="d-flex justify-content-end mt-2">
                                                    <Button color="primary btn-main mr-2" onClick={handleSavedocument}>
                                                        Ok
                                                    </Button>
                                                </div>
                                            </Col>
                                        </Row>
                                    </Dialog>
                                </Card>
                            </Col>
                            <Col xl={4}>
                                <div>
                                    <Card className="bg-form">
                                        <CardBody>
                                            <h4 className="card-title mb-3">Work Experience</h4>
                                            <DataTable value={workExperiences} responsiveLayout="scroll" className="mt-2"
                                                emptyMessage={<div className="empty-message-custom">No education details found.</div>}>
                                                <Column field="company_name" header="Company" />
                                                <Column field="job_title" header="Job Title" />
                                                <Column field="start_date" header="From Date" body={(rowData) => rowData.start_date ? new Date(rowData.start_date).toLocaleDateString() : ''} />
                                                <Column field="end_date" header="To Date" body={(rowData) => rowData.end_date ? new Date(rowData.end_date).toLocaleDateString() : ''} />
                                            </DataTable>
                                            <div className="block d-flex align-items-center justify-content-end">
                                                <a color="primary" className="anchr-title  mt-3" onClick={() => { setShowDialog(true); setFormValues([]) }}>
                                                    <i className="pi pi-plus me-1"></i> Add More
                                                </a>
                                            </div>
                                            <Dialog header={editIndex !== null ? "Edit Work Experience" : "Add Work Experience"} visible={showDialog}
                                                style={{ width: "30vw" }}
                                                onHide={() => setShowDialog(false)}                      >
                                                <Row className="mb-2">
                                                    <Col xl={12}>
                                                        <label htmlFor="company" className="block">Company</label>
                                                        <InputText
                                                            className="w-full"
                                                            value={formValues.company_name}
                                                            onChange={(e) => handleInputChange("company_name", e.target.value)} />
                                                    </Col>
                                                </Row>

                                                <Row className="mb-2">
                                                    <Col xl={12}>
                                                        <label htmlFor="website" className="block">Website</label>
                                                        <InputText id="website"
                                                            value={formValues.website}
                                                            onChange={(e) => handleInputChange("website", e.target.value)}
                                                            className="w-full" />
                                                    </Col>
                                                </Row>
                                                <Row className="mb-2">
                                                    <Col xl={12}>
                                                        <label htmlFor="jobTitle" className="block">Job Title</label>
                                                        <InputText id="jobTitle"
                                                            value={formValues.job_title}
                                                            onChange={(e) => handleInputChange("job_title", e.target.value)}
                                                            className="w-full" />
                                                    </Col>
                                                </Row>
                                                <Row className="mb-2">
                                                    <Col xl={12}>
                                                        <label htmlFor="fromDate" className="block">From Date</label>
                                                        <Calendar id="fromDate"
                                                            value={formValues.start_date}
                                                            onChange={(e) => handleInputChange("start_date", e.value)}
                                                            showIcon
                                                            className="w-full" />
                                                    </Col>
                                                </Row>
                                                <Row className="mb-2">
                                                    <Col xl={12}>
                                                        <label htmlFor="toDate" className="block">To Date</label>
                                                        <Calendar id="toDate"
                                                            value={formValues.end_date}
                                                            onChange={(e) => handleInputChange("end_date", e.value)}
                                                            showIcon className="w-full" />
                                                    </Col>
                                                </Row>
                                                <Row>
                                                    <Col xl={12}>
                                                        <div className="d-flex justify-content-end mt-2">
                                                            <Button color="primary btn-main mr-2" onClick={handleSave}>
                                                                Ok
                                                            </Button>
                                                        </div>
                                                    </Col>
                                                </Row>
                                            </Dialog>
                                            <ConfirmDialog />
                                        </CardBody>
                                    </Card>
                                </div>

                                <Card className="bg-form">
                                    <CardBody>
                                        <h4 className="card-title mb-3">Education Details</h4>
                                        <Row>
                                            <Col xl={12}>
                                                <div className="">
                                                    <Row>
                                                        <Col xl={12}>
                                                            <DataTable value={educationDetails} showGridlines
                                                                emptyMessage={<div className="empty-message-custom">No education details found.</div>}>
                                                                <Column field="degree" header="Degree"></Column>
                                                                <Column field="school_name" header="School"></Column>
                                                                <Column field="grade" header="Grade"></Column>
                                                                <Column field="start_year" header="Year"></Column>
                                                            </DataTable>
                                                            <div className="block d-flex align-items-center justify-content-end">
                                                                <a color="primary" className="anchr-title mt-3" onClick={() => setIsDialogVisible(true)}>
                                                                    <i className="pi pi-plus me-1"></i> Add More
                                                                </a>
                                                            </div>
                                                            <Dialog header="Add Education" visible={isDialogVisible} style={{ width: '30vw' }}
                                                                onHide={() => setIsDialogVisible(false)}>
                                                                <div className="field">
                                                                    <label htmlFor="degree" className="block mb-2">Degree</label>
                                                                    <InputText id="degree"
                                                                        value={newEducation.degree}
                                                                        onChange={(e) => setNewEducation({ ...newEducation, degree: e.target.value })}
                                                                        placeholder="Enter Degree"
                                                                        className="w-full" />
                                                                </div>
                                                                <div className="field mt-2">
                                                                    <label htmlFor="institution" className="block mb-2">School</label>
                                                                    <InputText id="institution"
                                                                        value={newEducation.school_name}
                                                                        onChange={(e) => setNewEducation({ ...newEducation, school_name: e.target.value })}
                                                                        placeholder="Enter Institution" className="w-full" />
                                                                </div>
                                                                <div className="field mt-2">
                                                                    <label htmlFor="grade" className="block mb-2">Grade</label>
                                                                    <InputText id="grade"
                                                                        value={newEducation.grade}
                                                                        onChange={(e) => setNewEducation({ ...newEducation, grade: e.target.value })}
                                                                        placeholder="Enter Grade/Percentage" className="w-full" />
                                                                </div>
                                                                <Row>
                                                                    <Col xl={6}>
                                                                        <div className="field">
                                                                            <label htmlFor="year" className="block  mb-2">Start Year</label>
                                                                            <Dropdown id="year"
                                                                                value={newEducation.start_year}
                                                                                onChange={(e) => setNewEducation({ ...newEducation, start_year: e.value })}
                                                                                options={years} placeholder="Select Year" className="w-full bgclr" />
                                                                        </div>
                                                                    </Col>
                                                                    <Col xl={6}>
                                                                        <div className="field">
                                                                            <label htmlFor="month" className="block  mb-2">Start Month</label>
                                                                            <Dropdown id="month"
                                                                                value={newEducation.start_month}
                                                                                onChange={(e) => setNewEducation({ ...newEducation, start_month: e.value })}
                                                                                options={months}
                                                                                placeholder="Select Month" className="w-full bgclr" />
                                                                        </div>
                                                                    </Col>
                                                                </Row>
                                                                <Row className="mt-2">
                                                                    <Col xl={6}>
                                                                        <div className="field">
                                                                            <label htmlFor="endYear" className="block">End Year</label>
                                                                            <Dropdown
                                                                                id="endYear"
                                                                                value={newEducation.end_year}
                                                                                onChange={(e) => setNewEducation({ ...newEducation, end_year: e.value })}
                                                                                options={years}
                                                                                placeholder="Select Year" className="w-full bgclr" />
                                                                        </div>
                                                                    </Col>
                                                                    <Col xl={6}>
                                                                        <div className="field">
                                                                            <label htmlFor="endMonth" className="block">End Month</label>
                                                                            <Dropdown id="endMonth"
                                                                                value={newEducation.end_month}
                                                                                onChange={(e) => setNewEducation({ ...newEducation, end_month: e.value })}
                                                                                options={months} placeholder="Select Month" className="w-full bgclr" />
                                                                        </div>
                                                                    </Col>
                                                                </Row>
                                                                <Row>
                                                                    <Col xl={12}>
                                                                        <div className="d-flex justify-content-end mt-2">
                                                                            <Button color="primary btn-main mr-2" onClick={handleSave1}>
                                                                                Ok
                                                                            </Button>
                                                                        </div>
                                                                    </Col>
                                                                </Row>
                                                            </Dialog>
                                                        </Col>
                                                    </Row>
                                                </div>
                                            </Col>
                                        </Row>
                                    </CardBody>
                                </Card>

                                <Card className="bg-form">
                                    <CardBody>
                                        <h4 className="card-title mb-2">Social Pages</h4>
                                        <Row>
                                            <Col xl={12}>
                                                <div className="">
                                                    <Row>
                                                        <Col xl={12}>
                                                            <Row className="align-items-center mt-2">
                                                                <Col xl={3}>
                                                                    <label className=" block">LinkedIn URL</label>
                                                                </Col>
                                                                <Col xl={9}>
                                                                    <InputText id="integer" className="w-full" style={{ position: "relative" }}
                                                                        value={linkdinval}
                                                                        onChange={(e) => { setlinkdinval(e.target.value) }} />
                                                                    <i className="pi pi-linkedin linkd-icon"
                                                                        style={{
                                                                            position: "absolute",
                                                                            right: "26px",
                                                                            top: "34%",
                                                                            transform: "translateY(-50%)",
                                                                            // cursor: "pointer"
                                                                        }}></i>
                                                                </Col>
                                                            </Row>

                                                            <Row className="mt-2 align-items-center">
                                                                <Col xl={3}>
                                                                    <label className=" block">Facebook URL</label>
                                                                </Col>
                                                                <Col xl={9}>
                                                                    <InputText id="integer" className="w-full" style={{ position: "relative" }}
                                                                        value={facebook}
                                                                        onChange={(e) => { setfacebook(e.target.value) }}
                                                                    />
                                                                    <i className="pi pi-facebook facebook-icon"
                                                                        style={{
                                                                            position: "absolute",
                                                                            right: "26px",
                                                                            top: "51%",
                                                                            transform: "translateY(-50%)",
                                                                            // cursor: "pointer"
                                                                        }}></i>
                                                                </Col>
                                                            </Row>

                                                            <Row className="mt-2 align-items-center">
                                                                <Col xl={3}>
                                                                    <div className="d-flex align-items-start">
                                                                        <label className=" block">Twitter URL</label>
                                                                    </div>
                                                                </Col>
                                                                <Col xl={9}>
                                                                    <InputText id="integer" className="w-full" style={{ position: "relative" }}
                                                                        value={twitter}
                                                                        onChange={(e) => { settwitter(e.target.value) }} />
                                                                    <i className="pi pi-twitter twitter-icon"
                                                                        style={{
                                                                            position: "absolute",
                                                                            right: "26px",
                                                                            top: "69%",
                                                                            transform: "translateY(-50%)",
                                                                            // cursor: "pointer"
                                                                        }}></i>
                                                                </Col>
                                                            </Row>

                                                            <Row className="mt-2 align-items-center">
                                                                <Col xl={3}>
                                                                    <div className="d-flex align-items-start">
                                                                        <label className=" block">Indeed URL</label>
                                                                    </div>
                                                                </Col>
                                                                <Col xl={9}>
                                                                    <InputText id="integer" className="w-full"
                                                                        value={Indeed}
                                                                        onChange={(e) => { setIndeed(e.target.value) }} />
                                                                    <i className="pi pi-info me-1 indeed-icon"
                                                                        style={{
                                                                            position: "absolute",
                                                                            right: "22px",
                                                                            top: "86%",
                                                                            transform: "translateY(-50%)",
                                                                            // cursor: "pointer"
                                                                        }}></i>
                                                                </Col>
                                                            </Row>
                                                        </Col>
                                                    </Row>
                                                </div>
                                            </Col>
                                        </Row>
                                    </CardBody>
                                </Card>
                            </Col>
                        </Row >
                        <Row className="align-items-center mb-3">
                            <Col md={12}>
                                <div className="d-flex justify-content-end">
                                    <button type="submit" class="btn btn-primary waves-effect waves-light btn btn-primary me-2 btn-main" >Save</button>
                                    <Link to={`/all_active_employees`} > <button type="button" class="btn btn-primary waves-effect waves-light me-2 cancel-outlinebtn" >Cancel<i className="pi pi-times me-1"></i></button></Link>
                                </div>
                            </Col>
                        </Row>
                    </form>
                    <Dialog
                        header="Duplicate Resumes"
                        visible={merge}
                        style={{ width: '30vw' }}
                        onHide={() => {
                            if (!merge) return;
                            setMerge(false);
                        }}
                        footer={footerContent}                    >
                        <p className="m-0">
                            <h4 className="popup-merge">The candidate already exists. Do you want to merge?</h4>
                        </p>
                    </Dialog>
                </Container >
            </div >
        </React.Fragment >
    )
}

export default CandidatePostFormExtra;
